import { render } from "./Active.vue?vue&type=template&id=ac58277c&ts=true"
import script from "./Active.vue?vue&type=script&lang=ts"
export * from "./Active.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Episcenter\\smartCity\\smartcity\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__